import { render, staticRenderFns } from "./PrizeDrawFileImport.vue?vue&type=template&id=2f1dc5f8&scoped=true"
import script from "./PrizeDrawFileImport.vue?vue&type=script&lang=js"
export * from "./PrizeDrawFileImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1dc5f8",
  null
  
)

export default component.exports